<template>
  <div class="home-box">
    <div class="home-bg">
      <div class="main_box">
        <div class="box_bg"></div>
        <div class="getway1"><img src="@/assets/images/getway.png" /></div>
        <div class="getway2"><img src="@/assets/images/getway.png" /></div>
        <div class="kou1 kou_an"><img src="@/assets/images/kou_01.png" /></div>
        <div class="kou2 kou_an"><img src="@/assets/images/kou_02.png" /></div>
        <div class="kou3 kou_an"><img src="@/assets/images/kou_01.png" /></div>
        <div class="kou4 kou_an"><img src="@/assets/images/kou_02.png" /></div>
        <div class="kou5 kou_an"><img src="@/assets/images/kou_01.png" /></div>
        <div class="kou6 kou_an"><img src="@/assets/images/kou_02.png" /></div>

        <div class="data_light data_light1 data_light1_an"><img src="@/assets/images/data_light.png" /></div>
        <div class="data_light data_light2 data_light2_an"><img src="@/assets/images/data_light.png" /></div>
        <div class="data_light data_light3 data_light3_an"><img src="@/assets/images/data_light.png" /></div>
        <div class="data_light data_light4 data_light4_an"><img src="@/assets/images/data_light.png" /></div>
        <div class="data_light data_light5 data_light5_an"><img src="@/assets/images/data_light.png" /></div>
        <div class="data_light data_light6 data_light6_an"><img src="@/assets/images/data_light.png" /></div>
        <div class="data_light data_light8 data_light8_an"><img src="@/assets/images/data_light.png" /></div>
        <div class="data_light data_light9 data_light9_an"><img src="@/assets/images/data_light.png" /></div>

        <div class="data_light data_light10 data_light10_an"><img src="@/assets/images/data_light.png" /></div>
        <div class="data_light data_light11 data_light11_an"><img src="@/assets/images/data_light.png" /></div>
        <div class="data_light data_light12 data_light12_an"><img src="@/assets/images/data_light.png" /></div>

        <div class="data_light data_light13 data_light13_an"><img src="@/assets/images/data_light.png" /></div>
        <div class="data_light data_light14 data_light14_an"><img src="@/assets/images/data_light.png" /></div>
        <div class="data_light data_light15 data_light15_an"><img src="@/assets/images/data_light.png" /></div>
        <div class="data_light data_light16 data_light16_an"><img src="@/assets/images/data_light.png" /></div>

        <div class="light_bar bar1"><img src="@/assets/images/icon1.png" /></div>
        <div class="light_bar bar2"><img src="@/assets/images/icon2.png" /></div>
        <div class="light_bar bar3"><img src="@/assets/images/icon3.png" /></div>
        <div class="light_bar bar4"><img src="@/assets/images/icon4.png" /></div>
        <div class="light_bar bar5"><img src="@/assets/images/light_bar.png" /></div>

        <div class="light light3" style="opacity: 1;">
          <img src="@/assets/images/light.png" class="light_open_an"/>
        </div>
        <div class="d_box" @click="newData.dialogVisible=true">
          <div class="big_circle"></div>
          <div class="small_circle"></div>
          <div class="d_sanjiao"><img src="@/assets/images/d_san.gif" /></div>
        </div>

      </div>
    </div>
    <div class="head">
      <img src="@/assets/images/page_head.png" />
    </div>

    <div class="home-left">
      <div class="home_pad">
        <div class="main-box">
          <div class="box_border t"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border r"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border b"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border l"><img src="@/assets/images/box_border.png" /></div>
          <box1></box1>
        </div>
        <div class="main-box">
          <div class="box_border t"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border r"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border b"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border l"><img src="@/assets/images/box_border.png" /></div>
          <box2 :itemData="resData.cpuAndMemory"></box2>
        </div>
        <div class="main-box">
          <div class="box_border t"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border r"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border b"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border l"><img src="@/assets/images/box_border.png" /></div>
          <box3></box3>
        </div>
      </div>
    </div>
    <div class="home-right">
      <div class="home_pad">
        <div class="main-box">
          <div class="box_border t"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border r"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border b"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border l"><img src="@/assets/images/box_border.png" /></div>
          <box4></box4>
        </div>
        <div class="main-box" style="height:29.3333%">
          <div class="box_border t"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border r"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border b"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border l"><img src="@/assets/images/box_border.png" /></div>
          <box5 :itemData="resData.equipmentQuantity"></box5>
        </div>
        <div class="main-box" style="height:37.3333%">
          <div class="box_border t"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border r"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border b"><img src="@/assets/images/box_border.png" /></div>
          <div class="box_border l"><img src="@/assets/images/box_border.png" /></div>
          <box6 :itemData="resData.trafficStatistics"></box6>
        </div>
      </div>
    </div>

    <!-- 查看弹框 -->
    <div
      class="box_control_bg"
      v-if="newData.dialogVisible"
      @click="closeBox"
    ></div>
    <div class="box_control" v-if="newData.dialogVisible">
      <div class="box_head">
        <div class="box_head_l">
          <div @click="checkType(0)" :class="strategyType==0 ? 'menu_one curr':'menu_one'">定时策略</div>
          <div @click="checkType(1)" :class="strategyType==1 ? 'menu_one curr':'menu_one'">立即策略</div>
        </div>
        <div class="add_item" @click="openEditWin('create')"><i class="add_c el-icon-document-add"></i>新增</div>
        <div class="box_close" @click="closeBox">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <el-scrollbar class="scroll_box">
          <el-table :data="newData.tableData">
            <el-table-column prop="title" label="策略名称"></el-table-column>
            <el-table-column prop="time" label="执行时间"></el-table-column>
            <el-table-column prop="gateway_name" label="设备"> </el-table-column>
            <el-table-column prop="light" label="亮度">
              <template slot-scope="scope">
                {{scope.row.light}}%
              </template>
            </el-table-column>
            <el-table-column prop="delay" label="延迟时间"></el-table-column>
            <el-table-column label="命令" prop="ste">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.ste"
                  :active-value="1"
                  :inactive-value="0"
                  active-color="#2f69fc"
                  inactive-color="#06103a"
                  @change="changeSwitch(scope.row)"
                />
              </template>
            </el-table-column>
            <el-table-column prop="edit" label="编辑" width="100">
              <template slot-scope="scope">
                <div class="edit-button">
                  <i
                    @click="openEditWin(scope.row)"
                    class="el-icon-edit pointer mar-r10"
                  ></i>
                  <i
                    class="el-icon-delete pointer"
                    @click="delItem(scope.row.id)"
                  ></i>
                </div>
              </template>
            </el-table-column>
          </el-table>
          
        </el-scrollbar>
      </div>
    </div>

    <!-- 查看子弹框 -->
    <div
      class="sub_box_control_bg"
      v-if="subDialogVisible"
      @click="closeSubBox"
    ></div>
    <div class="sub_box_control" v-if="subDialogVisible">
      <div class="box_head">
        <div class="menu_one">{{editType === 'create' ? '添加策略' : '修改策略'}}</div>
        <div class="box_close" @click="closeSubBox">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
    
          <el-form
            :model="editOne"
            label-position="left"
            label-width="80px"
          >
            <div class="form_con">
              <el-form-item label="策略名称" prop="title">
                <el-input v-model="editOne.title"></el-input>
              </el-form-item>
              <el-form-item label="时间段" prop="number">
                <el-time-picker
                  is-range
                  v-model="editOne.time"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                  value-format="HH:mm:ss" 
                  >
                </el-time-picker>
              </el-form-item>
              <el-form-item label="亮度%" prop="light">
                <el-input-number v-model="editOne.light" :step="5" step-strictly></el-input-number>
              </el-form-item>

              <el-form-item label="策略类型">
                <el-select
                  placeholder="请选择策略类型"
                  v-model="editOne.type"
                  style="width: 100%"
                >
                  <el-option
                    v-for="t in typeList"
                    :key="t.id"
                    :label="t.name"
                    :value="t.id"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="延迟" prop="delay">
                <el-input-number v-model="editOne.delay" step-strictly></el-input-number>
              </el-form-item>
            </div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="mw-edit-button" @click="subDialogVisible = false"
              >取消</el-button
            >
            <el-button
              type="primary"
              @click="createItem"
              v-if="editType === 'create'"
              >确 定</el-button
            >
            <el-button
              type="primary"
              @click="updateItem"
              v-if="editType === 'update'"
              >确 定</el-button
            >
          </div>
     
      </div>
    </div>

  </div>
</template>
<script>
import homeApi from "@/api/home/index";
import box1 from "@/components/home/box1.vue";
import box2 from "@/components/home/box2.vue";
import box3 from "@/components/home/box3.vue";
import box4 from "@/components/home/box4.vue";
import box5 from "@/components/home/box5.vue";
import box6 from "@/components/home/box6.vue";
export default {
  components: {
    box1,
    box2,
    box3,
    box4,
    box5,
    box6
  },
  data() {
    return {
      resData: {
        cpuAndMemory: [
          {
            timestamp: '00:00 00',
            cpu: 0,
            memory: 0
          }
        ],
        equipmentQuantity: {
          total: 0,
          gateway: 0,
          lamp: 0,
          lamp_online: 0,
          gateway_online: 0,
          lamp_offline: 0,
          gateway_offline: 0
        },
        trafficStatistics:[
          {
            timestamp: '00:00 00',
            usually: 0,
            edge: 0
          }
        ]
      },
      strategyType: 0,
      newData: {
        dialogVisible: false,
        tableData: [
          {
            id: 1,
            title: '策略001',
            time: '15:30-15:40',
            device: '网关1',
            light: '50%',
            delay: 0,
            state: 1
          },
          {
            id: 2,
            title: '策略002',
            time: '13:30-13:40',
            device: '网关2',
            light: '60%',
            delay: 0,
            state: 0
          },
          {
            id: 3,
            title: '策略003',
            time: '16:30-16:40',
            device: '网关3',
            light: '70%',
            delay: 0,
            state: 0
          },
          {
            id: 4,
            title: '策略004',
            time: '17:30-17:40',
            device: '网关4',
            delay: 0,
            light: '80%',
            state: 1
          }
        ]
      },
      typeList: [
        {
          id: 0,
          name: '定时策略'
        },
        {
          id: 1,
          name: '立即策略'
        }
      ],
      editType: -1,
      subDialogVisible: false,
      editOne: {
        id: null,
        title: '',
        time: '',
        light: 0,
        type: 0,
        delay: 0
      },
      lightInfo: [
        {
          lamp_id: 4,
          light: 0,
          ste: 1
        },
        {
          lamp_id: 3,
          light: 0,
          ste: 1
        },
        {
          lamp_id: 2,
          light: 0,
          ste: 1
        },
        {
          lamp_id: 1,
          light: 0,
          ste: 1
        }
      ],
      timer: null
    };
  },
  methods: {
    getData() {
      homeApi.dasboardData().then((res) => {
        if(res){
          if (res.data.code === 1000) {
            this.resData = res.data.data;
          }
        }else{
          this.$message.error('接口错误!');
        }
      });
    },
    closeBox() {
      // 关闭弹框
      this.newData.dialogVisible = false
    },
    closeSubBox() {
      // 关闭弹框
      this.subDialogVisible = false
    },
    checkType(type) {
      this.strategyType = type
      this.getTableData()
    },
    getTableData() {
      homeApi.strategyList({
        page: 1,
        pageSize: 50,
        type: this.strategyType
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.newData.tableData = resData.list;
        }
      });
    },
    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          id: null,
          title: '',
          time: '',
          light: 0,
          type: 0,
          delay: 0
        },
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          title: index.title,
          time: [index.time.split('-')[0],index.time.split('-')[1]],
          light: index.light,
          type: index.type,
          delay: index.delay
        };
        this.editType = "update";
      }
      this.subDialogVisible = true;
    },
    updateItem() {
      // console.log('this.editOne.time',this.editOne.time)
      this.editOne.time=this.editOne.time[0]+'-'+this.editOne.time[1]
      homeApi.strategyEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.subDialogVisible = false;
          this.getTableData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      this.editOne.time=this.editOne.time[0]+'-'+this.editOne.time[1]
      homeApi.strategyAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.subDialogVisible = false;
          this.getTableData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          homeApi.strategyDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData();
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeSwitch(row) {
      if(row.type==1){
        homeApi.sendGatewayStrategy({
          id: row.id,
          ste: row.ste
        }).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("下发成功");
            this.getTableData();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }else{
        homeApi.sendUsuallyStrategy({
          id: row.id,
          ste: row.ste
        }).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("下发成功");
            this.getTableData();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }

    }
  },
  mounted() {
    this.getTableData()
    // 下面为制作定时器（首页模块数据）
    this.getData();
    if (this.timer) {
      clearInterval(this.timer);
    } else {
      this.timer = setInterval(() => {
        setTimeout(() => {
          this.getData()
        }, 0);
      }, 6 * 1000);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  }
};
</script>
<style lang='less'>
.home-box {
  position: relative;
  width: 100%;
  height: 100%;
  background: #030d1e;
  overflow: hidden;
  .home-bg {
    position: absolute;
    left: 470px;
    top: 120px;
    bottom: 10px;
    right: 470px;
    overflow: hidden;
    background: url(../../assets/images/main_bg.png) 0 0 no-repeat;
    background-size: auto 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .head {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 2;
    text-align: center;
    padding: 0 20px;
    box-sizing: border-box;
    img{
      width:100%;
      height:auto;
    }
  }
  .home-left,.home-right{
    position: absolute;
    width: 450px;
    left:20px;
    top: 105px;
    bottom:20px;
    z-index: 9;
    background: #040d31;
    .home_pad {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 5px 10px;
      position: relative;
      overflow: hidden;
      .main-box {
        width: 100%;
        padding: 15px 0;
        height: 33.3333%;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        .box_border{
          position: absolute;
          width:10px;
          height:10px;
          line-height: 0;
          z-index: 99;
          img{
            width:100%;
            height:auto;
          }
        }
        .t{
          left:0;
          top:15px;
        }
        .r{
          right:0;
          top:15px;
          transform: rotate(90deg);
        }
        .b{
          right:0;
          bottom:15px;
          transform: rotate(180deg);
        }
        .l{
          left:0;
          bottom:15px;
          transform: rotate(270deg);
        }
      }
    }
  }
  .home-right{
    left:auto;
    right:20px;
  }
  .main_box{
    width:980px;
    height:750px;
    position: relative;
    img{
      width:100%;
      height:auto;
    }
    .box_bg{
      position: absolute;
      left:0;
      top:0;
      width:980px;
      height:750px;
      background: url(../../assets/images/box_bg.png) 0 0 no-repeat;
      background-size: 100% auto;
    }
    .getway1{
      position: absolute;
      left:150px;
      top:288px;
      width:200px;
      height:200px;
      z-index: 9;
    }
    .getway2{
      position: absolute;
      left:465px;
      top:98px;
      width:180px;
      height:180px;
      z-index: 9;
    }
    .kou1{
      position: absolute;
      left:186px;
      top:142px;
      width:94px;
      height:79px;
      z-index: 10;
    }
    .kou2{
      position: absolute;
      left:300px;
      top:145px;
      width:94px;
      height:79px;
      z-index: 10;
    }
    .kou3{
      position: absolute;
      left:140px;
      top:410px;
      width:96px;
      height:79px;
      z-index: 10;
    }
    .kou4{
      position: absolute;
      left:257px;
      top:412px;
      width:94px;
      height:79px;
      z-index: 10;
    }

    .kou5{
      position: absolute;
      left:457px;
      top:210px;
      width:80px;
      height:66px;
      z-index: 10;
    }
    .kou6{
      position: absolute;
      left:565px;
      top:211px;
      width:80px;
      height:66px;
      z-index: 10;
    }
    .light_bar{
      position: absolute;
      width:44px;
      height:267px;
      z-index: 12;
    }

    .bar1{
      width:133px;
      height:159px;
      top:582px;
      left:215px;
    }

    .bar2{
      width:88px;
      height:97px;
      top:530px;
      left:400px;
    }

    .bar3{
      width:100px;
      height:72px;
      top:485px;
      left:525px;
    }

    .bar4{
      width:79px;
      height:60px;
      top:395px;
      left:682px;
    }
    
    .bar5{
      top:122px;
      left:822px;
      transform: scale(0.8);
    }

    
    .light{
      position: absolute;
      width:240px;
      height:240px;
      z-index: 13;
      img{
        opacity: 0;
      }
    }
    
    
    .light3{
      top:54px;
      left:724px;
      transform: scale(0.85);
    }
    

    .data_light{
      position: absolute;
      width:56px;
      height:13px;
      z-index:8;
      opacity: 0;
    }
    
    .data_light1{
      top:184px;
      left:195px;
      transform:rotate(-30deg)
    }
    .data_light1_an{
      animation: data_light1 2s linear infinite;
    }

    .data_light2{
      top:280px;
      left:61px;
      transform:rotate(30deg)
    }
    .data_light2_an{
      animation: data_light2 2s linear infinite;
    }

    .data_light3{
      top:450px;
      left:277px;
      transform:rotate(30deg)
    }
    .data_light3_an{
      animation: data_light3 1.5s linear infinite;
    }

    .data_light4{
      top:495px;
      left:362px;
      transform:rotate(-30deg)
    }
    .data_light4_an{
      animation: data_light4 1.5s linear infinite;
    }

    .data_light5{
      top:508px;
      left:340px;
      transform:rotate(-30deg)
    }
    .data_light5_an{
      animation: data_light5 2s linear infinite;
    }

    .data_light6{
      top:458px;
      left:448px;
      transform:rotate(24deg);
    }
    .data_light6_an{
      animation: data_light6 1.5s linear 2s infinite;
    }

    .data_light8{
      top:550px;
      left:302px;
      transform:rotate(28deg);
    }
    .data_light8_an{
      animation: data_light8 2s linear 1s infinite;
    }

    .data_light9{
      top:630px;
      left:166px;
      transform:rotate(30deg);
    }
    .data_light9_an{
      animation: data_light9 2s linear 2s infinite;
    }

    .data_light10{
      top:190px;
      left:326px;
      transform:rotate(30deg);
    }
    .data_light10_an{
      animation: data_light10 2s linear 2s infinite;
    }

    .data_light11{
      top:248px;
      left:455px;
      transform:rotate(-36deg);
    }
    .data_light11_an{
      animation: data_light11 1s linear 2s infinite;
    }

    .data_light12{
      top:250px;
      left:588px;
      transform:rotate(30deg);
    }
    .data_light12_an{
      animation: data_light12 1.5s linear 1s infinite;
    }

    .data_light13{
      top:286px;
      left:662px;
      transform:rotate(-30deg);
    }
    .data_light13_an{
      animation: data_light13 1s linear 2.5s infinite;
    }

    .data_light14{
      top:299px;
      left:640px;
      transform:rotate(-30deg);
    }
    .data_light14_an{
      animation: data_light14 1.5s linear 1.5s infinite;
    }

    .data_light15{
      top:350px;
      left:585px;
      transform:rotate(31deg);
    }
    .data_light15_an{
      animation: data_light15 1.5s linear 3s infinite;
    }

    .data_light16{
      top:276px;
      left:708px;
      transform:rotate(27deg);
    }
    .data_light16_an{
      animation: data_light16 1.5s linear 3.5s infinite;
    }

    .d_box,.d_box2{
      width:66px;
      height:66px;
      left:215px;
      top:250px;
      position: absolute;
      z-index: 15;
      cursor: pointer;
      .big_circle{
        position: absolute;
        width:66px;
        height:30px;
        left:50%;
        top:50%;
        margin-top:-15px;
        margin-left:-33px;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        animation: big_circle 2s linear 1s infinite;
        background-image: url(../../assets/images/big_cricle.png);
        z-index: 1;
        opacity: 0;
      }
      
      .small_circle{
        width:46px;
        height:20px;
        left:50%;
        top:50%;
        position: absolute;
        margin-left:-23px;
        margin-top:-10px;
        background-position: center center;
        background-repeat: no-repeat;
        background-image: url(../../assets/images/big_cricle.png);
        background-size: 100% 100%;
        animation: small_circle 2s linear 1s infinite;
        z-index: 2;
        opacity: 0;
      }
      .d_sanjiao{
        width:32px;
        height:32px;
        left:50%;
        position: absolute;
        margin-left:-16px;
        bottom: 45px;
        animation: d_sanjiao 2s linear infinite;
        z-index:20
      }
      
    }
    .d_box2{
      left:520px;
      top:56px;
    }
    
  }

  .kou_an{
    animation: kou_tm 2s linear infinite;
  }
  .light_open_an{
    animation: light_open 1s ease-in forwards;
  }
  @keyframes kou_tm {
    0% {
      opacity: 0.3;
    }
    30% {
      opacity: 1;
    }
    50% {
      opacity: 1;
    }
    70% {
      opacity: 1;
    }
    100% {
      opacity: 0.3;
    }
  }

  @keyframes light_open {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }


  @keyframes data_light1 {
    0% {
      top:184px;
      left:195px;
      opacity: 1;
    }
    100% {
      top:264px;
      left:61px;
      opacity: 1;
    }
  }

  @keyframes data_light2 {
    0% {
      top:280px;
      left:61px;
      opacity: 1;
    }
    100% {
      top:352px;
      left:181px;
      opacity: 1;
    }
  }

  @keyframes data_light3 {
    0% {
      top:450px;
      left:277px;
      opacity: 1;
    }
    100% {
      top:490px;
      left:343px;
      opacity: 1;
    }
  }

  @keyframes data_light4 {
    0% {
      top:495px;
      left:362px;
      opacity: 1;
    }
    100% {
      top:458px;
      left:425px;
      opacity: 1;
    }
  }

  @keyframes data_light5 {
    0% {
      top:508px;
      left:340px;
      opacity: 1;
    }
    100% {
      top:612px;
      left:165px;
      opacity: 1;
    }
  }

  @keyframes data_light6 {
    0% {
      top:458px;
      left:448px;
      opacity: 1;
    }
    100% {
      top:510px;
      left:552px;
      opacity: 1;
    }
  }

  // @keyframes data_light7 {
  //   0% {
  //     top:500px;
  //     left:360px;
  //     opacity: 1;
  //   }
  //   100% {
  //     top:565px;
  //     left:468px;
  //     opacity: 1;
  //   }
  // }

  @keyframes data_light8 {
    0% {
      top:550px;
      left:302px;
      opacity: 1;
    }
    100% {
      top:610px;
      left:406px;
      opacity: 1;
    }
  }

  @keyframes data_light9 {
    0% {
      top:630px;
      left:166px;
      opacity: 1;
    }
    100% {
      top:700px;
      left:285px;
      opacity: 1;
    }
  }

  @keyframes data_light10 {
    0% {
      top:190px;
      left:326px;
      opacity: 1;
    }
    100% {
      top:240px;
      left:415px;
      opacity: 1;
    }
  }
  
  @keyframes data_light11 {
    0% {
      top:248px;
      left:455px;
      opacity: 1;
    }
    100% {
      top:226px;
      left:485px;
      opacity: 1;
    }
  }
  @keyframes data_light12 {
    0% {
      top:250px;
      left:588px;
      opacity: 1;
    }
    100% {
      top:280px;
      left:635px;
      opacity: 1;
    }
  }

  @keyframes data_light13 {
    0% {
      top:286px;
      left:662px;
      opacity: 1;
    }
    100% {
      top:275px;
      left:680px;
      opacity: 1;
    }
  }

  @keyframes data_light14 {
    0% {
      top:299px;
      left:640px;
      opacity: 1;
    }
    100% {
      top:336px;
      left:580px;
      opacity: 1;
    }
  }

  @keyframes data_light15 {
    0% {
      top:350px;
      left:585px;
      opacity: 1;
    }
    100% {
      top:400px;
      left:664px;
      opacity: 1;
    }
  }

  @keyframes data_light16 {
    0% {
      top:276px;
      left:708px;
      opacity: 1;
    }
    100% {
      top:336px;
      left:816px;
      opacity: 1;
    }
  }



  @keyframes big_circle {
    0% {
      opacity: 1;
      transform: scale(0.1);
    }
    50% {
      opacity: 1;
      transform: scale(1);
    }

    100% {
      opacity: 0;
      transform: scale(2);
    }
  }

  @keyframes small_circle {
    0% {
      opacity: 1;
      transform: scale(0.1);
    }
    50% {
      opacity: 1;
      transform: scale(1);
    }

    100% {
      opacity: 0;
      transform: scale(1.6);
    }
  }

   @keyframes d_sanjiao {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(15px);
    }
    100% {
      transform: translateY(0);
    }
  }


  
  
}

// 弹框

.box_control_bg{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  // background: rgba(0,0,0,.3);
  z-index:98;
}
.box_control{
  position: absolute;
  width: 1000px;
  height:600px;
  left:50%;
  margin-left:-500px;
  top:50%;
  margin-top:-300px;
  background: url(../../assets/images/dialog_box_bg.png) 0 0 no-repeat;
  background-size: 100% auto;
  z-index: 99;
  .box_head{
    padding:60px 100px 0 50px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    .box_head_l{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .menu_one{
        margin-right:20px;
        padding:6px 10px;
        border-radius: 5px;
        color:#fff;
        cursor: pointer;
      }
      .curr{
        background: #2757d6;
      }
      .control_one{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        span{
          color:#fff;
          font-size:14px;
        }
        .all_open{
          background: #2f69fc;
        }
      }
    }
    .add_item{
      color:#fff;
      font-size:16px;
      cursor: pointer;
      .add_c{
        font-size:16px;
        margin-right:5px;
      }
    }

    .box_close{
      position: absolute;
      top: 35px;
      right: 40px;
      border: none;
      outline: 0;
      cursor: pointer;
      font-size: 32px;
      i{
        color:#fff;
      }
    }
  }
  .box_body{
    position: absolute;
    left:25px;
    right:30px;
    top:100px;
    bottom:60px;
    .scroll_box{
      width:100%;
      height:100%;
      font-size:12px;
      color:#fff;
      line-height: 1.4;
      position: relative;
    }
  }
}


// 弹框

.sub_box_control_bg{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background: rgba(0,0,0,.3);
  z-index:100;
}
.sub_box_control{
  position: absolute;
  width: 623px;
  height:454px;
  left:50%;
  margin-left:-311px;
  top:50%;
  margin-top:-227px;
  background: url(../../assets/images/sub_dialog_box_bg.png) 0 0 no-repeat;
  background-size: 100% auto;
  z-index: 101;
  .box_head{
    padding:30px 50px 0 50px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .menu_one{
      color:#fff;
      font-size:20px;
      font-weight:bold;
      cursor: pointer;
    }

    .box_close{
      position: absolute;
      top: 20px;
      right: 20px;
      border: none;
      outline: 0;
      cursor: pointer;
      font-size: 32px;
      i{
        color:#fff;
      }
    }
  }
  .box_body{
    position: absolute;
    left:100px;
    right:100px;
    top:80px;
    bottom:40px;
    .scroll_box{
      width:100%;
      height:100%;
      font-size:12px;
      color:#fff;
      line-height: 1.4;
      position: relative;
    }
  }
}

.el-scrollbar__wrap{
  overflow-x: hidden !important;
}
.is-horizontal{
  display: none;
}
/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}

.el-table--border::after, .el-table--group::after, .el-table::before{
  background-color: #0b3363 !important;
}
.el-table{
  color:#fff !important;
  font-size:14px !important;
}
.el-table, .el-table__expanded-cell{
  background-color: #06103a !important;
}
.el-table th, .el-table tr{
  background-color: #06103a !important;
}
.el-table td, .el-table th.is-leaf{
  border-bottom: 1px solid #0b3363 !important;
}
.el-table--mini td, .el-table--mini th{
  padding: 10px 0 !important;
}
.el-table thead th,.el-table thead tr{
  color:#fff !important;
  background-color: #0a1f51 !important;
}
.el-table--enable-row-hover .el-table__body tr:hover > td{
  background-color: #172f68 !important;
}
.el-switch__core{
  border:1px solid #2f69fc !important;
}

.el-table .el-table__header th.is-leaf{
  border-bottom: none !important;
}

.el-input__inner{
  border:1px solid #fff !important
}

.el-input.is-active .el-input__inner, .el-input__inner:focus{
  border-color: #409EFF !important
}


.form_con{
  .el-form-item__label{
    color:#fff !important;
  }
  .el-date-editor--timerange.el-input__inner{
    width:342px !important;
  }
  .el-input-number--mini{
    line-height:32px !important;
  }
  .el-range-editor--mini.el-input__inner{
    height:32px !important;
  }
  .el-range-editor--mini .el-range-separator,.el-range-editor--mini .el-range__close-icon, .el-range-editor--mini .el-range__icon{
    line-height:25px !important;
  }
  
}
.el-scrollbar{
  min-height:80px !important;
}
.dialog-footer{
  padding-left: 80px;
}
.el-scrollbar__view{
  padding-right: 10px !important;
}

.el-message-box{
  background-color:#101c4d !important;
  border:1px solid #1777c0 !important;
}
.el-message-box__title{
  color:#fff !important;
}
.el-message-box__content{
  color: rgba(255,255,255,.8) !important;
}
.el-button{
  background: none !important;
  border: 1px solid rgb(47, 105, 252)  !important;
  color: #fff  !important;
}
.el-button--primary{
  color: #fff  !important;
  background: rgb(47, 105, 252)  !important;
}
</style>